import React from 'react';
import i18n from "i18next";
import { Dropdown, Button } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import settings from '../../virtuoso/settings';

const SettingsMenu = (props) => {

  const items = [
    // {
    //   key: '1',
    //   label: i18n.t('components.settings.taxonomy'),
    // },
    // {
    //   key: '2',
    //   label: i18n.t('components.settings.object'),
    // }
  ];

  const onMenuClick = (e) => {
    //console.log('click', e.key, props.element);
    const title = (props.title)?props.title: document.title;
    switch (e.key){
      // case '1' : 
      //   props.router.navigate("/schemes"); break;
      // case '2' : 
      //   props.router.navigate("/vocabs"); break;
      case '3' : 
        //Переключение будет сделано в методе AdmsRepository.swithCatalog
        props.onChange(settings.catalog.public, settings.catalog.graph.public);
        break; 
      case '4' : 
        //Переключение будет сделано в методе AdmsRepository.swithCatalog
        props.onChange(settings.catalog.signed, settings.catalog.graph.signed);
        break; 
      case '5' : 
        //Включить отобранные активы к публичный каталог
        props.onInclude(settings.catalog.public, settings.catalog.graph.public);
        break; 
      case '6' : 
        //Исключить отобранные активы их публичного каталога
        props.onExclude(settings.catalog.public, settings.catalog.graph.public);
        break; 
      // case '11' : 
      //   props.router.navigate("/sksaowl"); break;
      default:
        console.log("SettingsMenu.js unknow", e.key);
    }
  };
  
  const makeMenu = () => {
    //console.log("SettingsMenu.js makeMenu", props);
    const menuItems = [... items];
    // if (props.inGroup && props.inGroup.Expert){
    //     menuItems.push({key: '11', label: "Онтология каталога"}) ;
    // }
    if (settings.catalog.public && settings.catalog.signed && (settings.catalog.public != settings.catalog.signed)){
      menuItems.push({key: '100', type: 'divider'}); //dashed : true,
      if (settings.catalog.public != settings.catalog.iri)
        menuItems.push({key: '3', label: i18n.t('components.settings.catalog_public')}) ;
      if (settings.catalog.signed != settings.catalog.iri)
        menuItems.push({key: '4', label: i18n.t('components.settings.catalog_signed')}) ;
    };
    if (props.hasCondition){
      menuItems.push({key: '200', type: 'divider'}); //dashed : true,
      if (settings.catalog.public != settings.catalog.iri)
        menuItems.push({key: '5', label: i18n.t('components.settings.include_catalog')}) ;
      if (settings.catalog.signed != settings.catalog.iri)
        menuItems.push({key: '6', label: i18n.t('components.settings.exclude_catalog')}) ;

    };    
    return menuItems;
  };
  
  if (makeMenu().length==0)
    return (<></>);

  return (
      <Dropdown
        menu={{
          items: makeMenu(),
          onClick: onMenuClick,
        }}        
      >
        <Button icon={<SettingOutlined />}>          
        </Button>        
      </Dropdown>
  );
};

export default SettingsMenu;